import { render, staticRenderFns } from "./MotherForm.vue?vue&type=template&id=318fb2a3"
import script from "./MotherForm.vue?vue&type=script&lang=js"
export * from "./MotherForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports